export enum PermissionType {
  ViewChildCompanies = 1,
  VehiclesBaseInformation = 2,
  VehiclesEditNicknames = 3,
  VehiclesTelematics = 4,
  ChargersBaseInformation = 5,
  ChargersEditNicknames = 6,
  ChargersManagement = 7,
  ChargersReporting = 8,
  ServiceRequests = 9,
  ServiceRequestsHistory = 10,
  //View orders was removed - 11 (XOSPHERE-2775)
  //Submit and View quotes were removed - 12 and 13 (XOSPHERE-2775)
  OpenKnowledgeCenter = 14,
  OpenKnowledgeCenterWebWidget = 15,
  EditUtilityPolicies = 16,
  RequestService = 17,
  ViewWarrantyClaims = 18,
  SubmitWarrantyClaims = 19,
  //Quote Dealer and Base pricings were removed - 20 and 21 (XOSPHERE-2775)
  AccessReporting = 22,
  TenantAdministration = 23,
  DriverWiFiSetup = 24,
  ViewPowertrainsBaseInformation = 25,
  EditPowertrainsNicknames = 26,
  // View and Create PMSRs were removed - 27 and 28 (XOSPHERE-2775)
  ReceiveReportingEmails = 29,
  ViewAllWarrantyClaims = 30,
  // View, Create and ViewAll warranty registrations were removed - 31, 32, 33 (XOSPHERE-2775)
  ViewInspections = 34,
  CreateInspection = 35,
  AccessAllVehicles = 36,
  ViewSpareParts = 37,
  SetChargingSchedule = 38,
  StartStopCharging = 39,
  ViewBasicVehicleTelematics = 40,
  ManageTelematics = 41,
  EditEvccids = 42,
  ViewDiagnosticFaults = 43,
  // FOTA and Forge permissions 44, 45, 46 are not used by the portal
  PowerHubsBaseInformation = 47,
  PowerHubsControl = 48,
}
